import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "flex",
    justifyContent: "center",
    margin: "2.5em auto",
  },
  paragraph: {
    lineHeight: "1.5em",
    textAlign: "center",
    width: "41.5em",
  },
}));
const ParagraphStd = ({ paragraph }) => {
  const classes = useStyles();
  return (
    <Grid data-testid="ntkParagraph" container className={classes.grid}>
      <Typography className={classes.paragraph} color="secondary" variant="h3">
        {paragraph}
      </Typography>
    </Grid>
  );
};

export default ParagraphStd;
